var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.renderSlices),function(slice){return [_c(slice.component,_vm._b({key:slice._uid,tag:"component"},'component',slice.props,false))]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }